"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palazzuolo-sul-senio": {
    "e95230d9": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "acquadalto": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d51d5b0": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "badia-di-susisana": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd97c877": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "bibbiana": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c4b4ba4": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "casetta-di-tiara-mantigno-chiesa": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f356b2a": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "passo-sambuca": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "06acb177": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "salecchio": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "998471dc": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "skipSearch": false
    }],
    "visano": [{
      "hkey": "6e481b48",
      "slug": "palazzuolo-sul-senio",
      "name": "Palazzuolo sul Senio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;